<template>
  <div
    v-if="state"
    class="ais-Hits"
    :class="{ 'ais-Hits--empty': state.items.length === 0 }"
  >
    <slot
      v-if="!$slots['item'] && !$slots['banner'] && $slots['default']"
      name="default"
      :banner="state.banner"
      :items="state.items"
      :insights="state.insights"
      :send-event="state.sendEvent"
    />

    <slot
      v-if="state.banner"
      name="banner"
      :banner="showBanner ? state.banner : undefined"
    />

    <SanDefaultBanner
      v-else-if="state.banner?.image.urls[0].url"
      :link="state.banner?.link"
      :image="state.banner?.image"
    />

    <SanDefaultEmpty v-if="state.items.length === 0" />

    <ol
      v-else
      class="ais-Hits-list"
    >
      <li
        v-for="(item, i) in state.items"
        :key="item.objectID"
        class="ais-Hits-item"
        @click="() => state.sendEvent('click:internal', hit, 'Hit Clicked')"
        @auxclick="() => state.sendEvent('click:internal', hit, 'Hit Clicked')"
      >
        <slot
          name="item"
          :item="item"
          :index="i"
          :insights="state.insights"
          :send-event="state.sendEvent"
        >
          {{ `objectID: ${item.objectID}, index: ${i}` }}
        </slot>
      </li>
    </ol>
  </div>
</template>

<script setup>
import { inject } from 'vue' // eslint-disable-line
import { connectHitsWithInsights, connectPagination } from 'instantsearch.js/es/connectors' // eslint-disable-line
import { useConnector } from '@/composables'
import SanDefaultEmpty from '@/components/instant-search/SanDefaultEmpty.vue'
import SanDefaultBanner from '@/components/instant-search/SanDefaultBanner.vue'

const props = defineProps({
  showBanner: { type: Boolean, default: true },
  escapeHTML: { type: Boolean, default: true },
  transformItems: { type: Function, default: undefined }
})

const state = useConnector(connectHitsWithInsights, props)

// const instantSearchInstance = inject('$_ais_instantSearchInstance')
// instantSearchInstance.value.addWidgets([connectPagination(() => null)({ /* ... */ })])
</script>
